export const WAIT_TO_FIRE_INITIAL_TRACKING = 'WAIT_TO_FIRE_INITIAL_TRACKING';
export function waitToFireInitialTracking() {
    return { type: WAIT_TO_FIRE_INITIAL_TRACKING };
}

export const READY_TO_FIRE_INITIAL_TRACKING = 'READY_TO_FIRE_INITIAL_TRACKING';
export function readyToFireInitialTracking() {
    return { type: READY_TO_FIRE_INITIAL_TRACKING };
}
